<template>
  <v-layout align-center row class="mt-4 mb-2">
    <v-flex class="subtitle-icon-container">
      <img class="subtitle-icon-img" src="../../../../static/2dsearch-ai/2dsearch-ai-logo-icon.svg" alt="">
    </v-flex>
    <v-layout align-center row :class="secondaryText && 'subtitle-container ml-4'">
      <span v-if="title" class="subtitle-text" :class="ish3 ? 'subtitle-text-h3' : 'subtitle-text-h2'" v-html="title"></span>
      <v-layout column v-if="isResearchQuestionInput">
        <v-text-field
          :outline="true"
          :placeholder="researchQuestionPlaceholder"
          @click="errorMessageRQInput=false"
          v-model="researchQuestion"
          @keyup.enter="$emit('handleRQonEnter')"
        ></v-text-field>
        <span :class="showErrorMessageRQInput ? 'error-msg-active' : 'error-msg'" v-html="showErrorMessageRQInput ? errorMessageRQInput : ''"></span>
      </v-layout>
      <InlineActionBtn
        v-if="hasEdit"
        text="Edit"
        icon="edit"
        @onClickAction="$emit('onEditClick')"
      ></InlineActionBtn>
      <CustomButton
        v-if="secondaryText"
        :text="secondaryText"
        :icon="secondaryIcon"
        :isSecondary="true"
        @onClick="$emit('onSecondaryActionClick')"
      ></CustomButton>
    </v-layout>
  </v-layout>
</template>

<script>
import '../../../style/_variables.scss'
import { CustomButton, InlineActionBtn } from '../utils/buttons'
export default {
  name: 'SearchAISubtitle',
  components: {CustomButton, InlineActionBtn},
  props: {
    title: {default: null, type: String},
    hasEdit: {default: false, type: Boolean},
    isResearchQuestionInput: {default: false, type: Boolean},
    researchQuestionPlaceholder: {default: null, type: String},
    secondaryText: {default: null, type: String},
    secondaryIcon: {default: null, type: String},
    ish3: {default: false, type: Boolean}
  },
  computed: {
    showErrorMessageRQInput: {
      get () { return this.$store.getters.getShowErrorMessageRQInput }
    },
    errorMessageRQInput: {
      get () { return this.$store.state.searchAiState.errorMessageRQInput },
      set (value) { this.$store.commit('setShowErrorMessageRQInput', value) }
    },
    researchQuestion: {
      get () { return this.$store.state.searchAiState.researchQuestionInput },
      set (value) { this.$store.commit('setResearchQuestionInput', value) }
    }
  }
}
</script>

<style scoped lang="scss">
.subtitle {
  &-container {
    justify-content: space-between;
  }
  &-icon {
    &-container {
      max-width: 50px;
    }
    &-img {
      width: 32px;
      margin-top: 15px;
    }
  }
  &-text {
    font-weight: bold;
    &-h2 {
      font-size: $font-size-large;
    }
    &-h3 {
      font-size: $font-size-med;
    }
  }
}
.error-msg, .error-msg-active {
   color: $orange;
   height: 21px;
   width: 100%;
   margin-top: -25px;
   padding-top: 5px;
   &-active {
     border-top: 2px solid $orange;
   }
 }

</style>



// WEBPACK FOOTER //
// src/components/parts/searchAi/SearchAISubtitle.vue